import { render, staticRenderFns } from "./MalKabulDetayButton.vue?vue&type=template&id=21392d93&"
import script from "./MalKabulDetayButton.vue?vue&type=script&lang=js&"
export * from "./MalKabulDetayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports